module.exports = __webpack_public_path__ + "img/white.95de8214.svg";